export const modal = {
    addReport: ['Добавление доклада', 'Add report dialog'],
    airportICAOCode: ['Код аэропорта ICAO', 'Airport ICAO code'],
    bioNight: ['БИО НОЧЬ', 'BIO NIGHT'],
    captainComment: ['Комментарий КВС', 'Captain comment'],
    changeUser: ['Смена пользователя', 'Change user dialog'],
    checkList: ['КОНТРОЛЬНЫЙ СПИСОК', 'CHECK LIST'],
    document: ['Документ', 'Document'],
    editCrewDutyTimeFlight: ['Изменить рабочее время экипажа на рейсе {{title}}', 'Edit crew duty time on Flight {{title}}'],
    editReport: ['Редактирование доклада', 'Edit report dialog'],
    editService: ['Редактирование операции', 'Edit service dialog'],
    endLeg: ['ЗАВЕРШЕНИЕ УЧАСТКА', 'END LEG'],
    enterPass: ['Введите пароль', 'Enter password'],
    filterDialog: ['Настройка параметров фильтра', 'Filter dialog'],
    findText: ['Найти текст', 'Find text'],
    from: ['От', 'From'],
    independentFlight: ['САМОСТОЯТЕЛЬНЫЙ НАЛЁТ', 'INDEPENDENT FLIGHT'],
    loginDialog: ['Вход в систему', 'Login dialog'],
    nearestToRoute: ['Ближайшие к трассе', 'Nearest to route'],
    notamAccessDenied: [
        'Доступ запрещен. Чтобы получить его, обратитесь к администратору EFB',
        'Access is denied. To get it, please contact your EFB administrator.',
    ],
    notamPreview: ['Предварительный просмотр НОТАМ', 'NOTAM preview'],
    number: ['Номер', 'Number'],
    ofpSelectConfirm: ['Подтверждение выбора OFP', 'OFP select confirm'],
    placeEmpty: ['Место пустое', 'Place is empty'],
    requestNoticesModal: ['Запрос НОТАМов', 'Request notices modal'],
    reviewedContinue: ['Ознакомлен, продолжить работу', 'Reviewed, continue working'],
    scope: ['Область', 'Scope'],
    selectBackupFiles: [
        'Выберите файлы резервного копирования для восстановления приложения',
        'Select backup files for restore application',
    ],
    selectPeriodDownload: ['Выберите период для загрузки данных', 'Select period to download data'],
    sequenceNumber: ['Порядковый номер', 'Sequence number'],
    signaturePopupText: ['Всплывающий текст подписи', 'Signature popup text'],
    signatureTelegramText: ['Текст подписи телеграммы', 'Signature telegram text'],
    signingFlightTaskTitle: ['Подпись титульной страницы задания', 'Signing the flight task title'],
    startLeg: ['НАЧАЛО УЧАСТКА', 'START LEG'],
    taskTitle: ['Заголовок задания', 'Task title'],
    telegramTitleSignature: ['Подпись телеграммы ({{title}})', 'Telegram ({{title}}) signature'],
    ticket: ['Билет', 'Ticket'],
    to: ['До', 'To'],
    user: ['Пользователь', 'User'],
};
